import { useState, useCallback } from 'react';

// Services

import ClientsService from '../services/clients.service';

export default function GetCurrencyConversion() {
    const [getCurrencyConversionIsLoading, setGetCurrencyConversionIsLoading] = useState(false);
    const [getCurrencyConversionError, setGetCurrencyConversionError] = useState(null);
    const [currencyConversion, setCurrencyConversion] = useState([]);

    // Generate Income Declaration

    const handleGetCurrencyConversion = useCallback(async (data, handleSetisIncomeValid, minimumValues) => {
        setGetCurrencyConversionIsLoading(true);
        setGetCurrencyConversionError(null);

        try {
            const minimumCurrencyCode = data.currency_code === '928'
                ? '840'
                : data.currency_code;

            const minimumAmount = Number(
                minimumValues.find(item => item.value === minimumCurrencyCode)?.minimum_amount ?? 0
            );

            let userAmount = Number(data.amount);

            if (data.currency_code === '928') {
                const currency = {
                    amount: data.amount,
                    currency_code: '840'
                }
                const request = await ClientsService.currencyConversion(currency);

                userAmount = Number(request?.data?.data?.amount ?? 0);
            }

            const isIncomeValid = userAmount <= minimumAmount;

            handleSetisIncomeValid(isIncomeValid);

            setGetCurrencyConversionIsLoading(false);
            setGetCurrencyConversionError(null);

            return isIncomeValid;
        } catch (error) {
            handleSetisIncomeValid(false);

            setGetCurrencyConversionIsLoading(false);
            setGetCurrencyConversionError(error.response?.data?.message || error.message);

            return false;
        }
    }, []);

    return {
        getCurrencyConversionIsLoading,
        getCurrencyConversionError,
        currencyConversion,
        handleGetCurrencyConversion,
    }
}
